/**
 * Quantas pílulas de fonte cabem numa LINHA só (Contexto do cartão flutuante,
 * §5.1). As que não cabem viram o "+N" no fim da mesma linha, junto com as
 * excedentes que já vieram cortadas (`fontesExcedentes`). Sempre ao menos uma
 * pílula: o rótulo longo corta com "…".
 *
 * Pura: `pilulasQueCabem({ larguras: [80, 90], disponivel: 150, gap: 4, larguraDoMais: 28, excedentes: 0 })` → 1.
 * Sem medida (`disponivel` falsy, jsdom) devolve todas.
 */
function somaComGap(larguras, quantidade, gap) {
  let soma = 0
  for (let i = 0; i < quantidade; i += 1) soma += Number(larguras[i]) || 0
  return soma + gap * Math.max(0, quantidade - 1)
}

export function pilulasQueCabem({ larguras, disponivel, gap = 0, larguraDoMais = 0, excedentes = 0 }) {
  const lista = larguras || []
  const total = lista.length
  if (!total) return 0
  if (!disponivel) return total
  for (let quantidade = total; quantidade > 1; quantidade -= 1) {
    const ocultas = total - quantidade + (Number(excedentes) || 0)
    const mais = ocultas > 0 ? gap + larguraDoMais : 0
    if (somaComGap(lista, quantidade, gap) + mais <= disponivel) return quantidade
  }
  return 1
}
